import { getImageSet } from 'Util/DataUtils';
import icDashboard from 'Assets/img/sidebar/ic_dashboard.png';
import icDashboard2 from 'Assets/img/sidebar/ic_dashboard@2x.png';
import icDashboard3 from 'Assets/img/sidebar/ic_dashboard@3x.png';
import icConsult from 'Assets/img/sidebar/ic_consult.png';
import icConsult2 from 'Assets/img/sidebar/ic_consult@2x.png';
import icConsult3 from 'Assets/img/sidebar/ic_consult@3x.png';
import icSetting from 'Assets/img/sidebar/ic_setting.png';
import icSetting2 from 'Assets/img/sidebar/ic_setting@2x.png';
import icSetting3 from 'Assets/img/sidebar/ic_setting@3x.png';
import icHomeActive from 'Assets/img/sidebar/ic_home_active.png';
import icHomeActive2 from 'Assets/img/sidebar/ic_home_active@2x.png';
import icHomeActive3 from 'Assets/img/sidebar/ic_home_active@3x.png';
import icWorkLogs from 'Assets/img/sidebar/ic_work_logs.png';
import icWorkLogs2 from 'Assets/img/sidebar/ic_work_logs@2x.png';
import icWorkLogs3 from 'Assets/img/sidebar/ic_work_logs@3x.png';
import icWorkLogsActive from 'Assets/img/sidebar/ic_work_logs_active.png';
import icWorkLogsActive2 from 'Assets/img/sidebar/ic_work_logs_active@2x.png';
import icWorkLogsActive3 from 'Assets/img/sidebar/ic_work_logs_active@3x.png';
import icComment from 'Assets/img/sidebar/ic_comment.png';
import icComment2 from 'Assets/img/sidebar/ic_comment@2x.png';
import icComment3 from 'Assets/img/sidebar/ic_comment@3x.png';
import icCommentActive from 'Assets/img/sidebar/ic_comment_active.png';
import icCommentActive2 from 'Assets/img/sidebar/ic_comment_active@2x.png';
import icCommentActive3 from 'Assets/img/sidebar/ic_comment_active@3x.png';
import icAccountBook from 'Assets/img/sidebar/ic_account_book.png';
import icAccountBook2 from 'Assets/img/sidebar/ic_account_book@2x.png';
import icAccountBook3 from 'Assets/img/sidebar/ic_account_book@3x.png';
import icAccountBookActive from 'Assets/img/sidebar/ic_account_book_active.png';
import icAccountBookActive2 from 'Assets/img/sidebar/ic_account_book_active@2x.png';
import icAccountBookActive3 from 'Assets/img/sidebar/ic_account_book_active@3x.png';
import icSalesNoteActive from 'Assets/img/sidebar/ic_sales_note_active.png';
import icSalesNoteActive2 from 'Assets/img/sidebar/ic_sales_note_active@2x.png';
import icSalesNoteActive3 from 'Assets/img/sidebar/ic_sales_note_active@3x.png';
import icFile from 'Assets/img/sidebar/ic_file.png';
import icFile2 from 'Assets/img/sidebar/ic_file@2x.png';
import icFile3 from 'Assets/img/sidebar/ic_file@3x.png';
import icFileActive from 'Assets/img/sidebar/ic_file_active.png';
import icFileActive2 from 'Assets/img/sidebar/ic_file_active@2x.png';
import icFileActive3 from 'Assets/img/sidebar/ic_file_active@3x.png';
import icSettingActiveVi from 'Assets/img/sidebar/ic_setting_active_vi.png';
import icSettingActiveVi2 from 'Assets/img/sidebar/ic_setting_active_vi@2x.png';
import icSettingActiveVi3 from 'Assets/img/sidebar/ic_setting_active_vi@3x.png';

// ko_renewal
import icHomeKo1 from 'Assets/img/sidebar/ic_home_20.png';
import icHomeKo2 from 'Assets/img/sidebar/ic_home_20@2x.png';
import icHomeKo3 from 'Assets/img/sidebar/ic_home_20@3x.png';
import icHomeActiveKo1 from 'Assets/img/sidebar/ic_home_active_20.png';
import icHomeActiveKo2 from 'Assets/img/sidebar/ic_home_active_20@2x.png';
import icHomeActiveKo3 from 'Assets/img/sidebar/ic_home_active_20@3x.png';
import icSalesNoteKo1 from 'Assets/img/sidebar/ic_sales_note_20.png';
import icSalesNoteKo2 from 'Assets/img/sidebar/ic_sales_note_20@2x.png';
import icSalesNoteKo3 from 'Assets/img/sidebar/ic_sales_note_20@3x.png';
import icContractKo1 from 'Assets/img/sidebar/ic_contract_20.png';
import icContractKo2 from 'Assets/img/sidebar/ic_contract_20@2x.png';
import icContractKo3 from 'Assets/img/sidebar/ic_contract_20@3x.png';
import icAccountBookKo1 from 'Assets/img/sidebar/ic_account_book_20.png';
import icAccountBookKo2 from 'Assets/img/sidebar/ic_account_book_20@2x.png';
import icAccountBookKo3 from 'Assets/img/sidebar/ic_account_book_20@3x.png';
import icReportKo1 from 'Assets/img/sidebar/ic_report_20.png';
import icReportKo2 from 'Assets/img/sidebar/ic_report_20@2x.png';
import icReportKo3 from 'Assets/img/sidebar/ic_report_20@3x.png';
import icChatKo1 from 'Assets/img/sidebar/ic_chat_20.png';
import icChatKo2 from 'Assets/img/sidebar/ic_chat_20@2x.png';
import icChatKo3 from 'Assets/img/sidebar/ic_chat_20@3x.png';
import icFileKo1 from 'Assets/img/sidebar/ic_file_20.png';
import icFileKo2 from 'Assets/img/sidebar/ic_file_20@2x.png';
import icFileKo3 from 'Assets/img/sidebar/ic_file_20@3x.png';
import icLogKo1 from 'Assets/img/sidebar/ic_log_20.png';
import icLogKo2 from 'Assets/img/sidebar/ic_log_20@2x.png';
import icLogKo3 from 'Assets/img/sidebar/ic_log_20@3x.png';
import icCartKo1 from 'Assets/img/sidebar/ic_cart_20.png';
import icCartKo2 from 'Assets/img/sidebar/ic_cart_20@2x.png';
import icCartKo3 from 'Assets/img/sidebar/ic_cart_20@3x.png';
import icOrderKo1 from 'Assets/img/sidebar/ic_order_20.png';
import icOrderKo2 from 'Assets/img/sidebar/ic_order_20@2x.png';
import icOrderKo3 from 'Assets/img/sidebar/ic_order_20@3x.png';
import icTransactionKo1 from 'Assets/img/sidebar/ic_transaction_20.png';
import icTransactionKo2 from 'Assets/img/sidebar/ic_transaction_20@2x.png';
import icTransactionKo3 from 'Assets/img/sidebar/ic_transaction_20@3x.png';
import icBudgetKo1 from 'Assets/img/sidebar/ic_budget_20.png';
import icBudgetKo2 from 'Assets/img/sidebar/ic_budget_20@2x.png';
import icBudgetKo3 from 'Assets/img/sidebar/ic_budget_20@3x.png';
import icCalendarKo1 from 'Assets/img/sidebar/ic_calendar_20.png';
import icCalendarKo2 from 'Assets/img/sidebar/ic_calendar_20@2x.png';
import icCalendarKo3 from 'Assets/img/sidebar/ic_calendar_20@3x.png';
import icSettingKo1 from 'Assets/img/sidebar/ic_setting_20.png';
import icSettingKo2 from 'Assets/img/sidebar/ic_setting_20@2x.png';
import icSettingKo3 from 'Assets/img/sidebar/ic_setting_20@3x.png';
import icNoticeKo1 from 'Assets/img/sidebar/ic_notice_20.png';
import icNoticeKo2 from 'Assets/img/sidebar/ic_notice_20@2x.png';
import icNoticeKo3 from 'Assets/img/sidebar/ic_notice_20@3x.png';
import icPrivateNoteKo1 from 'Assets/img/sidebar/ic_private_note_20.png';
import icPrivateNoteKo2 from 'Assets/img/sidebar/ic_private_note_20@2x.png';
import icPrivateNoteKo3 from 'Assets/img/sidebar/ic_private_note_20@3x.png';
import icStaffKo1 from 'Assets/img/sidebar/ic_staff_20.png';
import icStaffKo2 from 'Assets/img/sidebar/ic_staff_20@2x.png';
import icStaffKo3 from 'Assets/img/sidebar/ic_staff_20@3x.png';

export default function SidebarIcon() {
  return {
    icon: [
      { name: 'home', icon: getImageSet([icHomeKo1, icHomeKo2, icHomeKo3]), activeIcon: getImageSet([icHomeActiveKo1, icHomeActiveKo2, icHomeActiveKo3]) },
      { name: 'sales-note', icon: getImageSet([icSalesNoteKo1, icSalesNoteKo2, icSalesNoteKo3]) },
      { name: 'contract', icon: getImageSet([icContractKo1, icContractKo2, icContractKo3]) },
      { name: 'account-book', icon: getImageSet([icAccountBookKo1, icAccountBookKo2, icAccountBookKo3]) },
      { name: 'report', icon: getImageSet([icReportKo1, icReportKo2, icReportKo3]) },
      { name: 'chat', icon: getImageSet([icChatKo1, icChatKo2, icChatKo3]) },
      { name: 'file', icon: getImageSet([icFileKo1, icFileKo2, icFileKo3]) },
      { name: 'log', icon: getImageSet([icLogKo1, icLogKo2, icLogKo3]) },
      { name: 'cart', icon: getImageSet([icCartKo1, icCartKo2, icCartKo3]) },
      { name: 'order', icon: getImageSet([icOrderKo1, icOrderKo2, icOrderKo3]) },
      { name: 'transaction', icon: getImageSet([icTransactionKo1, icTransactionKo2, icTransactionKo3]) },
      { name: 'budget', icon: getImageSet([icBudgetKo1, icBudgetKo2, icBudgetKo3]) },
      { name: 'calendar', icon: getImageSet([icCalendarKo1, icCalendarKo2, icCalendarKo3]) },
      { name: 'setting', icon: getImageSet([icSettingKo1, icSettingKo2, icSettingKo3]) },
      { name: 'notice', icon: getImageSet([icNoticeKo1, icNoticeKo2, icNoticeKo3]) },
      { name: 'private-note', icon: getImageSet([icPrivateNoteKo1, icPrivateNoteKo2, icPrivateNoteKo3]) },
      { name: 'staff', icon: getImageSet([icStaffKo1, icStaffKo2, icStaffKo3]) },
      // vietnam
      { name: 'vi-home', icon: getImageSet([icDashboard, icDashboard2, icDashboard3]), activeIcon: getImageSet([icHomeActive, icHomeActive2, icHomeActive3]) },
      { name: 'vi-work-logs', icon: getImageSet([icWorkLogs, icWorkLogs2, icWorkLogs3]), activeIcon: getImageSet([icWorkLogsActive, icWorkLogsActive2, icWorkLogsActive3]) },
      { name: 'vi-comment', icon: getImageSet([icComment, icComment2, icComment3]), activeIcon: getImageSet([icCommentActive, icCommentActive2, icCommentActive3]) },
      { name: 'vi-account-book', icon: getImageSet([icAccountBook, icAccountBook2, icAccountBook3]), activeIcon: getImageSet([icAccountBookActive, icAccountBookActive2, icAccountBookActive3]) },
      { name: 'vi-sales-note', icon: getImageSet([icConsult, icConsult2, icConsult3]), activeIcon: getImageSet([icSalesNoteActive, icSalesNoteActive2, icSalesNoteActive3]) },
      { name: 'vi-file', icon: getImageSet([icFile, icFile2, icFile3]), activeIcon: getImageSet([icFileActive, icFileActive2, icFileActive3]) },
      { name: 'vi-setting', icon: getImageSet([icSetting, icSetting2, icSetting3]), activeIcon: getImageSet([icSettingActiveVi, icSettingActiveVi2, icSettingActiveVi3]) },
    ],
  };
}
